
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { Component, OnDestroy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})

export class NavigationComponent implements OnDestroy {

  showTestLabel = environment.showTestLabel;
  userIsLoggedIn: boolean;
  userRoles: Array<string> = [];

  private loginSubscription: Subscription;

  constructor(private auth: AuthService) {
    this.loginSubscription = this.auth
      .getLoginState()
      .subscribe(loginState => {
        this.userIsLoggedIn = loginState;
        this.userRoles = this.auth.getUserRoles();
      });
  }

  private navigationConfig: any = {
    packer: {},
    admin: {
      'dropdown': {
        0: {
          title: 'Kundenverwaltung',
          icon: 'fas fa-users',
          pages: {
            0: {
              icon: 'fas fa-users',
              label: 'Kassenkunden',
              url: '/customer'
            },
            1: {
              icon: 'fas fa-users',
              label: 'Sonstige Kunden',
              url: '/private-customer'
            }
          }
        },
        1: {
          title: 'Abrechnung',
          icon: 'fas fa-euro-sign',
          pages: {
            0: {
              icon: 'fa fa-cubes',
              label: 'Gelieferte Pakete',
              url: '/billing/delivered-parcels'
            },
            1: {
              icon: 'fas fa-euro-sign',
              label: 'Kassenrechnungen',
              url: '/billing/insurance'
            },
            3: {
              icon: 'fas fa-euro-sign',
              label: 'Kundenrechnungen',
              url: '/billing/customer'
            },
            4: {
              icon: 'fas fa-euro-sign',
              label: 'Sonstige Kundenrechnungen',
              url: '/billing/private-customer'
            },
            5: {
              icon: 'fas fa-file-csv',
              label: 'Rechnungsexport',
              url: '/billing/invoice-export'
            },
          }
        },
        2: {
          title: 'Lieferungen',
          icon: 'fas fa-money-check',
          pages: {
            0: {
              icon: 'fas fa-money-check',
              label: 'Anstehende Lieferungen',
              url: '/shipping/index'
            },
            1: {
              icon: 'fas fa-money-check',
              label: 'Anstehende Abholungen',
              url: '/shipping/pickup'
            },
            2: {
              icon: 'fas fa-truck',
              label: 'Rücksendungen',
              url: '/return-shipment'
            },
            3: {
              icon: 'fas fa-hourglass-half',
              label: 'Verspätete Lieferungen',
              url: '/delayed-shipments'
            },
          }
        },
        3: {
          title: 'Produktverwaltung',
          icon: 'fas fa-warehouse',
          pages: {
            0: {
              icon: 'fas fa-cubes',
              label: 'Produkte',
              url: '/warehouse/product'
            },
            1: {
              icon: 'fas fa-clipboard-list',
              label: 'Lieferanten',
              url: '/warehouse/supplier'
            }
          }
        },
        4: {
          title: 'Systemeinstellungen',
          icon: 'fas fa-cogs',
          pages: {
            0: {
              icon: 'fas fa-cogs',
              label: 'Stammdaten',
              url: '/admin/company'
            },
            1: {
              icon: 'fas fa-briefcase-medical',
              label: 'Pflegekassen',
              url: '/insurer'
            },
            2: {
              icon: 'fas fa-clipboard-list',
              label: 'Kostenträger',
              url: '/admin/accounting-group'
            },
            3: {
              icon: 'fas fa-clipboard-list',
              label: 'Datenannahmestellen',
              url: '/admin/invoice-collector'
            },
            34: {
              icon: 'fas fa-circle',
              label: 'Lieferzyklen',
              url: '/admin/delivery-cycle'
            },
            5: {
              icon: 'fas fa-th',
              label: 'Lieferblöcke',
              url: '/admin/delivery-chunk'
            },
            6: {
              icon: 'fas fa-box',
              label: 'Paketklassen',
              url: '/admin/parcel'
            },
          }
        }
      }
    },
  };

  ngOnDestroy(): void {
    this.loginSubscription.unsubscribe()
  }

  /**
   * Gibt die Navigation für eine bestimmte Rolle zurück.
   */
  getNavigation = (userRole: string, type: string) => {
    if (this.navigationConfig !== undefined && this.navigationConfig.hasOwnProperty(userRole)) {
      if (this.navigationConfig[userRole].hasOwnProperty(type)) {
        return Object.keys(this.navigationConfig[userRole][type])
          .map(index => {
            return this.navigationConfig[userRole][type][index];
          });
      }
    }
    return [];
  };

  /**
   * Gibt die Unterseiten eines Dropdownmenüs als Array zurück.
   */
  getPages = (object: any) => {
    if (object.hasOwnProperty('pages')) {
      return Object.keys(object.pages).map(index => {
        return object.pages[index];
      });
    }
    return [];
  };
}
